export interface ErrorReportContext {
  source: 'mutation' | 'query'
  key?: unknown
  status: number | null
}

export type ErrorReporter = (error: unknown, ctx: ErrorReportContext) => void

let current: ErrorReporter = (error, ctx) => {
  console.error(`[${ctx.source}] failed`, ctx, error)
}

export function setErrorReporter(reporter: ErrorReporter): void {
  current = reporter
}

export function getErrorReporter(): ErrorReporter {
  return current
}
